import serviceJava from "../utils/requestJava";

export default {
   // 获取直播列表
  getLiveReport: (params) => serviceJava.post(`/ess-live-api/unionLive/do/preview`, params),
  // 学员端获取机构权限和客服信息
  getUnionInfo: (params) => serviceJava.get(`/ess-union-api/lm-union-info/do/get-union-info`, params),
};
